var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn &&
    _vm.trialInfo.remainingDays <= 0 &&
    _vm.planWizardCompleted === false &&
    _vm.isRoot
    ? _vm._m(0)
    : _c(
        "div",
        {
          staticClass: "position-relative h-100 w-100",
          class: { "dark-mode": _vm.users.darkMode, "new-theme": _vm.newTheme },
          attrs: { id: "app" },
        },
        [
          _c("SuspendedModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.suspendModalVisible,
                expression: "suspendModalVisible",
              },
            ],
            on: { cancel: _vm.closeSuspendedModal },
          }),
          _vm._v(" "),
          !_vm.suspendModalVisible && _vm.shouldSelectPlanEnabled
            ? _c("LimitedModal", {
                on: {
                  cancel: function ($event) {
                    _vm.shouldSelectPlanEnabled = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.CONFIG.FEATURES.HEYSUPSIS_ENABLED ? _c("HeySupsis") : _vm._e(),
          _vm._v(" "),
          _vm.visitorDetailPopup
            ? _c("VisitorDetailPopup", { attrs: { visibleMail: false } })
            : _vm._e(),
          _vm._v(" "),
          _vm.whatsappImportState &&
          _vm.whatsappImportState.status === "processing"
            ? _c("WhatsappImportStatusViewer", {
                attrs: { state: _vm.whatsappImportState },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("WindowManager"),
          _vm._v(" "),
          _vm.isLoggedIn &&
          _vm.isSiteSetupCompleted() &&
          !_vm.isNeededShowResetPasswordModal()
            ? _c("NewsModal")
            : _vm._e(),
          _vm._v(" "),
          _vm.site != null && _vm.site._id != null
            ? _c("router-view")
            : _vm._e(),
          _vm._v(" "),
          _c("v-tour", {
            key: "hit-tour-" + _vm.language,
            attrs: {
              callbacks: _vm.tourCallbacks,
              steps: _vm.steps,
              name: "hit-tour",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (tour) {
                  return [
                    _c(
                      "transition",
                      { attrs: { name: "fade" } },
                      _vm._l(tour.steps, function (step, index) {
                        return tour.currentStep === index
                          ? _c(
                              "v-step",
                              {
                                key: index,
                                attrs: {
                                  "is-first": tour.isFirst,
                                  "is-last": tour.isLast,
                                  labels: tour.labels,
                                  "next-step": tour.nextStep,
                                  "previous-step": tour.previousStep,
                                  step: step,
                                  stop: tour.stop,
                                },
                              },
                              [
                                _c("div", {
                                  attrs: { slot: "actions" },
                                  slot: "actions",
                                }),
                              ]
                            )
                          : _vm._e()
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _vm.isSiteSetupCompleted() && !_vm.isNeededShowResetPasswordModal()
            ? _c(
                "a-modal",
                {
                  attrs: {
                    cancelText: _vm.$t("tour.skip2"),
                    okText: _vm.$t("tour.startTour"),
                    title:
                      _vm.$t("tour.hi") +
                      " " +
                      _vm.loggedUserName +
                      ", " +
                      _vm.$t("tour.welcomeTo"),
                    centered: "",
                  },
                  on: { cancel: _vm.skipTour, ok: _vm.showTour },
                  model: {
                    value: _vm.tourModalVisible,
                    callback: function ($$v) {
                      _vm.tourModalVisible = $$v
                    },
                    expression: "tourModalVisible",
                  },
                },
                [
                  _c("div", [
                    _c("p", [_vm._v(_vm._s(_vm.$t("tour.firstTimeIntro")))]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentRunningTour()
            ? _c(
                "div",
                { staticClass: "tourButtonsContainer" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { size: "large" },
                      on: {
                        click: function () {
                          return (
                            _vm.$tours[_vm.currentRunningTour().name].skip() ||
                            _vm.disableChatFakeMode()
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("tour.skip")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$tours[_vm.currentRunningTour().name].isFirst
                    ? _c(
                        "a-button",
                        {
                          attrs: {
                            id: "prevStepButton",
                            size: "large",
                            type: "primary",
                          },
                          on: {
                            click: function () {
                              return _vm.$tours[
                                _vm.currentRunningTour().name
                              ].previousStep()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("tour.prevStep")) + "\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$tours[_vm.currentRunningTour().name].isLast
                    ? _c(
                        "a-button",
                        {
                          attrs: {
                            id: "nextStepButton",
                            size: "large",
                            type: "primary",
                          },
                          on: {
                            click: function () {
                              return _vm.$tours[
                                _vm.currentRunningTour().name
                              ].nextStep()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("tour.nextStep")) + "\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$tours[_vm.currentRunningTour().name].isLast
                    ? _c(
                        "a-button",
                        {
                          attrs: { size: "large", type: "primary" },
                          on: {
                            click: function () {
                              return (
                                _vm.$tours[
                                  _vm.currentRunningTour().name
                                ].finish() || _vm.disableChatFakeMode()
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("tour.finish")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              staticClass: "multiSessionClass",
              attrs: {
                closable: false,
                footer: null,
                visible: _vm.multiSessionMode && _vm.isLoggedIn,
                centered: "",
              },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex flex-column py-4" },
                [
                  _c("p", { staticStyle: { "font-size": "20px" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.multiModeAlertDesc")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "align-self-center",
                      attrs: { size: "large", type: "primary" },
                      on: { click: _vm.reloadPage },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.useHereText")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.isSiteSetupCompleted()
            ? _c(
                "a-modal",
                {
                  staticClass: "multiSessionClass",
                  attrs: {
                    closable: false,
                    footer: null,
                    title: _vm.$t("message.resetPassword"),
                    visible:
                      _vm.isNeededShowResetPasswordModal() &&
                      !_vm.isSiteSetupCompleted(),
                  },
                },
                [
                  _c("ResetPassword", {
                    attrs: { "on-completed": _vm.initTour },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              staticClass: "multiSessionClass",
              attrs: {
                closable: false,
                footer: null,
                visible: _vm.userRoleUpdated && _vm.isLoggedIn,
                centered: "",
              },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex flex-column py-4" },
                [
                  _c("p", { staticStyle: { "font-size": "20px" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.userRoleChanged")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "align-self-center",
                      attrs: { size: "large", type: "primary" },
                      on: { click: _vm.forceToMainPath },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.toMainPath")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.isSiteSetupCompleted()
            ? _c(
                "a-modal",
                {
                  staticClass: "fastWizardModal",
                  style: { width: "100%", height: "100%", margin: 0 },
                  attrs: {
                    id: "fastWizardModal",
                    closable: false,
                    footer: null,
                    title: null,
                    visible: !_vm.isSiteSetupCompleted(),
                  },
                },
                [_c("FastWizardV2")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.videoCallMode ? _c("VideoCallScreen") : _vm._e(),
          _vm._v(" "),
          _c("OffLine", { staticClass: "h-100 w-100" }),
          _vm._v(" "),
          _vm.isLoggedIn && _vm.settings.privateChatEnabled && !_vm.isAdmin
            ? _c("UserChatChannelSideBar")
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("BillingWizard")
  },
]
render._withStripped = true

export { render, staticRenderFns }